export default __webpack_public_path__ + "static/media/4_of_hearts.436fe356.png";